var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTrainingSyllabus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.964 79.268C61.6 79.268 79.14 61.688 79.14 40 79.14 18.312 61.6.73 39.964.73S.786 18.312.786 40c0 21.687 17.54 39.268 39.178 39.268Z",
    fill: "#EAF1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.515 28.941H20.301v19.444h38.214V28.94Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.777 55.106V33.468",
    stroke: "#050505",
    strokeWidth: 0.707,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.408 28.942c10.555 0 19.107 3.438 19.107 7.678v1.18l8.94-4.332-28.028-14.71-.019-.013-.02.013-28.02 14.71 8.94 4.332v-1.18c-.007-4.241 8.545-7.68 19.1-7.68Z",
    fill: "#3585F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39.428 47.038-.02.013-.02-.013-19.087-9.24V50.36c0 4.241 8.552 7.68 19.107 7.68s19.107-3.439 19.107-7.68V37.8l-19.087 9.24Z",
    fill: "#3585F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.56 61.25H65v-4.882c0-.855.692-1.54 1.538-1.54h.485c.852 0 1.537.692 1.537 1.54v4.882Z",
    stroke: "#050505",
    strokeWidth: 0.707,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingSyllabus);
export default __webpack_public_path__ + "static/media/TrainingSyllabus.32dece744158973024e40e35adc5bf4f.svg";
export { ForwardRef as ReactComponent };